import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import "@/App.css";

import { AuthProvider, useAuth } from "@/lib/auth.jsx";
import { ThemeProvider } from "@/lib/theme.jsx";
import Layout from "@/components/Layout";
import LoginPage from "@/pages/LoginPage";
import OverviewPage from "./pages/OverviewPage";
import BackupStatusPage from "./pages/BackupStatusPage";
import ResellersPage from "@/pages/ResellersPage";
import ResellerDetailPage from "@/pages/ResellerDetailPage";
import CloudsPage from "@/pages/CloudsPage";
import CloudDetailPage from "@/pages/CloudDetailPage";
import JobsPage from "@/pages/JobsPage";
import JobDetailPage from "@/pages/JobDetailPage";
import AuditPage from "@/pages/AuditPage";
import LogsPage from "@/pages/LogsPage";
import TokensIndexPage from "@/pages/TokensIndexPage";
import InfrastructurePage from "@/pages/InfrastructurePage";
import TopologyPage from "@/pages/TopologyPage";
import TemplatesPage from "@/pages/TemplatesPage";
import CustomAppsPage from "@/pages/CustomAppsPage";
import SouveraWorkspacePage from "@/pages/SouveraWorkspacePage";
import BackupImportPage from "@/pages/BackupImportPage";
import ApiDocsPage from "@/pages/ApiDocsPage";
import StatisticsPage from "@/pages/StatisticsPage";
import HealthPage from "@/pages/HealthPage";
import AlertCenterPage from "@/pages/AlertCenterPage";

function Protected({ children }) {
    const { user, loading } = useAuth();
    const loc = useLocation();
    if (loading) return <div className="p-8 text-zinc-500">Authenticating…</div>;
    if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
    return children;
}

export default function App() {
    return (
        <BrowserRouter>
            <ThemeProvider>
                <AuthProvider>
                <Routes>
                    <Route path="/login" element={<LoginPage />} />
                    <Route
                        path="/"
                        element={
                            <Protected>
                                <Layout />
                            </Protected>
                        }
                    >
                        <Route index element={<OverviewPage />} />
                        <Route path="statistics" element={<StatisticsPage />} />
                        <Route path="backup-status" element={<BackupStatusPage />} />
                        <Route path="health" element={<HealthPage />} />
<Route path="alerts" element={<AlertCenterPage />} />
                        <Route path="resellers" element={<ResellersPage />} />
                        <Route path="resellers/:id" element={<ResellerDetailPage />} />
                        <Route path="clouds" element={<CloudsPage />} />
                        <Route path="clouds/:id" element={<CloudDetailPage />} />
                        <Route path="jobs" element={<JobsPage />} />
                        <Route path="jobs/:id" element={<JobDetailPage />} />
                        <Route path="audit" element={<AuditPage />} />
                        <Route path="logs" element={<LogsPage />} />
                        <Route path="tokens" element={<TokensIndexPage />} />
                        <Route path="infrastructure" element={<InfrastructurePage />} />
                        <Route path="topology" element={<TopologyPage />} />
                        <Route path="templates" element={<TemplatesPage />} />
                        <Route path="custom-apps" element={<CustomAppsPage />} />
                        <Route path="souvera" element={<SouveraWorkspacePage />} />
                        <Route path="import" element={<BackupImportPage />} />
                        <Route path="reference" element={<ApiDocsPage />} />
                    </Route>
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </AuthProvider>
            </ThemeProvider>
        </BrowserRouter>
    );
}
